import { Action, createLogic, Logic } from "redux-logic";

import { actionTypes as messagesActionTypes, actions as messagesActions } from "reducer/messages";
import { IRootState } from "reducer";

const messagesLogic = createLogic({
    type: messagesActionTypes.ADD_TO_STACK,
    latest: false,
    warnTimeout: 0,

    async process({action, getState}: {action: Action<messagesActionTypes.ADD_TO_STACK, {key: number | string}>, getState: () => IRootState}, dispatch) {
        await setTimeout(() => {
            if (getState().messages.messagesStack.length) {
                dispatch(messagesActions.deleteFromActive((action.payload)));
            }
        }, 4000);
    }
});

export default [
    messagesLogic as Logic
];